// Onay ve uyarı pencereleri (docs/styleguide/pencereler.md). sweetalert2 yalnız taşıyıcıdır: odak tuzağı, Esc/perde,
// modalın üstünde açılma. İçerik (ikon karosu, başlık, açıklama) bizim işaretlememizdir; paketin ikon ve başlık alanı
// kullanılmaz. Stil `assets/css/dialog.css`.
import Swal from 'sweetalert2/dist/sweetalert2.esm.js'
import i18n from '../i18n'

const ICONS = {
  danger: 'fa-regular fa-triangle-exclamation',
  warning: 'fa-regular fa-triangle-exclamation',
  primary: 'fa-regular fa-circle-question',
  info: 'fa-regular fa-circle-info'
}

let uid = 0

export function escapeHtml(value) {
  return String(value ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c])
}

function dialogClasses(tone) {
  return {
    container: 'vega-dialog-backdrop',
    popup: `vega-dialog vega-dialog--${tone}`,
    htmlContainer: 'vega-dialog__content',
    actions: 'vega-dialog__actions',
    confirmButton: `vega-dialog__btn vega-dialog__btn--${tone === 'danger' ? 'danger' : 'primary'}`,
    denyButton: 'vega-dialog__btn',
    cancelButton: 'vega-dialog__btn'
  }
}

// `$swal` bu örnektir: doğrudan `fire` eden kod da aynı kabukta ve aynı düğme sırasında (Vazgeç solda) açılır.
// Paket seçenekleri sığ birleştirir; `showClass`/`hideClass` bu yüzden perde anahtarlarıyla birlikte yazılır.
export const Dialog = Swal.mixin({
  buttonsStyling: false,
  reverseButtons: true,
  showClass: { popup: 'vega-dialog-in', backdrop: 'swal2-backdrop-show', icon: '' },
  hideClass: { popup: 'vega-dialog-out', backdrop: 'swal2-backdrop-hide', icon: '' },
  customClass: dialogClasses('primary')
})

/**
 * Onay sorar; onaylanırsa true, Vazgeç/Esc/perde false döner.
 * tone: 'danger' (geri alınamaz; kırmızı onay, odak Vazgeç'te) | 'warning' | 'primary' | 'info'.
 * text tek paragraf ya da paragraf dizisidir. `html` metnin altına eklenir ve çağıran kaçırmış olmalıdır.
 */
export function confirmDialog({ tone = 'primary', icon, title, text, html = '', confirmText, cancelText, showConfirm = true, didOpen }) {
  const id = `vega-dialog-${++uid}`
  const paragraphs = (Array.isArray(text) ? text : [text]).filter(Boolean)
  const body = '<div class="vega-dialog__body">'
    + `<span class="vega-dialog__icon" aria-hidden="true"><i class="${icon || ICONS[tone]}"></i></span>`
    + '<div class="vega-dialog__main">'
    + (title ? `<h2 id="${id}-title" class="vega-dialog__title">${escapeHtml(title)}</h2>` : '')
    + paragraphs.map(p => `<p class="vega-dialog__text">${escapeHtml(p)}</p>`).join('')
    + html
    + '</div></div>'

  return Dialog.fire({
    html: body,
    showConfirmButton: showConfirm,
    showCancelButton: true,
    confirmButtonText: escapeHtml(confirmText || i18n.global.t('Yes')),
    cancelButtonText: escapeHtml(cancelText || i18n.global.t('Cancel')),
    focusConfirm: tone !== 'danger',
    focusCancel: tone === 'danger',
    customClass: dialogClasses(tone),
    didOpen: popup => {
      if (title) popup.setAttribute('aria-labelledby', `${id}-title`)
      if (didOpen) didOpen(popup)
    }
  }).then(result => result.isConfirmed === true)
}
